const TOKEN_KEY = 'susha_auth_token';
const USER_KEY = 'susha_auth_user';
const ENTERPRISE_KEY = 'susha_auth_enterprise';
const ROLE_KEY = 'susha_auth_role';
const MEMBERSHIPS_KEY = 'susha_auth_memberships';
const APPS_KEY = 'susha_auth_apps';
const SELECTED_APP_KEY = 'susha_auth_selected_app';

export function getAuthToken() {
  return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
}

export function getAuthSession() {
  try {
    const token = localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY);
    const userRaw = localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);
    const enterpriseRaw = localStorage.getItem(ENTERPRISE_KEY) || sessionStorage.getItem(ENTERPRISE_KEY);
    const role = localStorage.getItem(ROLE_KEY) || sessionStorage.getItem(ROLE_KEY);
    const membershipsRaw = localStorage.getItem(MEMBERSHIPS_KEY) || sessionStorage.getItem(MEMBERSHIPS_KEY);
    const appsRaw = localStorage.getItem(APPS_KEY) || sessionStorage.getItem(APPS_KEY);
    const selectedApp = localStorage.getItem(SELECTED_APP_KEY) || sessionStorage.getItem(SELECTED_APP_KEY);
    return {
      token,
      user: userRaw ? JSON.parse(userRaw) : null,
      enterprise: enterpriseRaw ? JSON.parse(enterpriseRaw) : null,
      role,
      memberships: membershipsRaw ? JSON.parse(membershipsRaw) : [],
      apps: appsRaw ? JSON.parse(appsRaw) : [],
      selected_app: selectedApp || null,
    };
  } catch {
    return { token: null, user: null, enterprise: null, role: null, memberships: [], apps: [], selected_app: null };
  }
}

export function setAuthSession(payload = {}) {
  const token = payload?.token || null;
  const user = payload?.user || null;
  const enterprise = payload?.enterprise || null;
  const role = payload?.role || null;
  const memberships = Array.isArray(payload?.memberships) ? payload.memberships : [];
  const apps = Array.isArray(payload?.apps) ? payload.apps : [];
  const selectedApp = payload?.selected_app || null;

  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    sessionStorage.setItem(TOKEN_KEY, token);
  }
  if (user) {
    const serialized = JSON.stringify(user);
    localStorage.setItem(USER_KEY, serialized);
    sessionStorage.setItem(USER_KEY, serialized);
  }
  if (enterprise) {
    const serialized = JSON.stringify(enterprise);
    localStorage.setItem(ENTERPRISE_KEY, serialized);
    sessionStorage.setItem(ENTERPRISE_KEY, serialized);
  }
  if (role) {
    localStorage.setItem(ROLE_KEY, role);
    sessionStorage.setItem(ROLE_KEY, role);
  }
  if (memberships.length) {
    const serialized = JSON.stringify(memberships);
    localStorage.setItem(MEMBERSHIPS_KEY, serialized);
    sessionStorage.setItem(MEMBERSHIPS_KEY, serialized);
  }
  if (apps.length) {
    const serialized = JSON.stringify(apps);
    localStorage.setItem(APPS_KEY, serialized);
    sessionStorage.setItem(APPS_KEY, serialized);
  }
  if (selectedApp) {
    localStorage.setItem(SELECTED_APP_KEY, selectedApp);
    sessionStorage.setItem(SELECTED_APP_KEY, selectedApp);
  }

  return { token, user, enterprise, role, memberships, apps, selected_app: selectedApp };
}

export function clearAuthSessionStorage() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(ENTERPRISE_KEY);
  localStorage.removeItem(ROLE_KEY);
  localStorage.removeItem(MEMBERSHIPS_KEY);
  localStorage.removeItem(APPS_KEY);
  localStorage.removeItem(SELECTED_APP_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(ENTERPRISE_KEY);
  sessionStorage.removeItem(ROLE_KEY);
  sessionStorage.removeItem(MEMBERSHIPS_KEY);
  sessionStorage.removeItem(APPS_KEY);
  sessionStorage.removeItem(SELECTED_APP_KEY);
}
